module.exports = __webpack_public_path__ + "static/media/city.71c9d8c3.csv";